<script>
    import {sgettext} from '../../i18n.js';
    export let row = {};

    const MANUALLY_COMPLETED = 1;
    const MANUALLY_EXPIRED = 2;
    
</script>

{#if  row.manually_changed_instance_status == MANUALLY_EXPIRED}
    <span class="badge badge-pill" style="background-color:#adadad; color:white; font-weight: bold;">{sgettext('$$MANUALLY_EXPIRED_1$$')}</span>
{:else if row.manually_changed_instance_status == MANUALLY_COMPLETED}
    <span class="badge badge-pill" style="background-color:#adadad; color:white; font-weight: bold;">{sgettext('$$MANUALLY_COMPLETED_1$$')}</span>
{:else}
    <span class="badge badge-pill" style="background-color:#adadad; color:white; font-weight: bold;">{sgettext('$$EXPIRED_1$$')}</span>
{/if}